import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, input } from '../../../../component/component'

export function getTableDiv(value){

  var div =
    $('<div>')
    .text(value)
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if(column.value === undefined){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  if (filter.slice(0,2) == '<=') {
    var f = filter.slice(2) * 1
    var c = column.value * 1
    if(c <= f){
      return true
    } else {
      return false
    }

  } else if (filter.slice(0,2) == '>=') {
    var f = filter.slice(2) * 1
    var c = column.value * 1
    if(c >= f){
      return true
    } else {
      return false
    }

  } else if(filter.slice(0,1) == '<'){
    var f = filter.slice(1) * 1
    var c = column.value * 1
    if(c < f){
      return true
    } else {
      return false
    }

  } else if (filter.slice(0,1) == '>') {
    var f = filter.slice(1) * 1
    var c = column.value * 1
    if(c > f){
      return true
    } else {
      return false
    }

  } else {
    var f = filter * 1
    var c = column.value * 1
    if(c === f){
      return true
    } else {
      return false
    }

  }

}

export function getFormField(o,p,field){

  var format = function(value){
    return value + ''
  }

  var parse = function(value){
    value = value.trim() * 1
    return value
  }

  var validate = function(value){
    if(
      (value && value * 1 == value) ||
      (!value && field.optional)
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
    })

  var disabled = field.edit ? false : true

  var inputDiv =
    input(disabled)
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
      console.log(parse(value))
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/number/number.js